var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 90,
    viewBox: "0 0 46 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.845 66.1607L36.3016 1.10177L33.8601 2.67857L31.4184 1L29.4346 2.78035L25.2127 10.9699L26.4335 14.6324L24.9075 16.311V18.6L23.178 19.8208L25.3653 25.1618L23.4832 29.0786L18.5491 33.3514L12.852 35.0809L13.4624 42.0497L8.98608 53.3422L4.45891 60.9214L4.81498 68.348L2.98377 73.1295L3.49244 78.7249L1.05082 80.8613L1 84.7272L3.08551 88.0844L31.4184 89L34.0635 86.711L34.4703 84.422L36.912 85.185L38.4888 83.6081L42.9651 83.2011L42.6599 81.5734L45.4576 77.7075L45.0507 76.1306L43.016 75.1642L41.4391 69.6705L38.845 66.1607Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh);
export default __webpack_public_path__ + "static/media/NH.b0612a00274c0f2b5908aa2501f5dc09.svg";
export { ForwardRef as ReactComponent };